import { render, staticRenderFns } from "./Walls.vue?vue&type=template&id=35fe7191&"
import script from "./Walls.vue?vue&type=script&lang=js&"
export * from "./Walls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports